export default __webpack_public_path__ + "static/flexible-photo-delivery-92047cc1f98d27ae910eccdaf3cd6e12.jpg";